/**
 * Gets some information on the client running the script.
 * 
 * At the moment only the clients OS is detected
 * 
 * @param string  uaString  The string that should be evaluated. Under normal circumstances it should be navigator.userAgent.
 * 
 * @return Object Return an object [detectedOS, detectedOSVersion, detectedDevice]. Only detectedOS is supported so far.
 * detectedOS values are:
 *  - not reviewed so far
 *  - Android
 *  - Apple iPadOS
 *  - Chromecast
 *  - ChromeOS
 *  - iOS
 *  - Linux on Kindle 4
 *  - Linux, x32
 *  - Linux, x64
 *  - MacOS
 *  - Windows, x32
 *  - Windows, x64
 *  - Windows Phone
 *  - Roku Ultra
 * 
 */
export function GetHostInformation(uaString: string) {
  var host = {
    detectedOS: "not reviewed so far",
    detectedOSVersion: "not reviewed so far",
    detectedDevice: "not reviewed so far",
  };
  if (uaString.match(/Linux; Android/)) {
    host.detectedOS = "Android";
  } else if (uaString.match(/iPhone/)) {
    host.detectedOS = "iOS";
  } else if (uaString.match(/Windows Phone/)) {
    host.detectedOS = "Windows Phone";
  } else if (uaString.match(/Windows NT/)) {
    host.detectedOS = "Windows";
    if (uaString.match(/WOW64/)) {
      host.detectedOS += ", x32";
    } else {
      host.detectedOS += ", x64";
    }
  } else if (uaString.match(/X11/)) {
    if (uaString.match(/Linux armv7l like Android/)) {
      host.detectedOS = "Linux on Kindle 4";
    } else if (uaString.match(/CrOS/)) {
      host.detectedOS = "ChromeOS";
    } else {
      host.detectedOS = "Linux";
      if (uaString.match(/x86_64/)) {
        host.detectedOS += ", x64";
      } else if (uaString.match(/x86_32/)) {
        host.detectedOS += ", x32";
      }
    }
  } else if (uaString.match(/iPad/)) {
    host.detectedOS = "Apple iPadOS";
  } else if (uaString.match(/Macintosh/)) {
    if (navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
      host.detectedOS = "Apple iPadOS";
    } else {
      host.detectedOS = "MacOS";
    }
  } else if (uaString.match(/CrKey/)) {
    host.detectedOS = "Chromcast";
  } else if (uaString.match(/Roku/)) {
    host.detectedOS = "Roku Ultra";
  }
  return host;
}
